// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

$('.sub-menu').addClass('navbar-dropdown is-boxed');


$('.slk-testimonials').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  autoplay: true,
  arrows: true,
  autoplaySpeed: 4000,
  prevArrow: '<button type="button" class="slick-prev">prev</button>',
  nextArrow: '<button type="button" class="slick-next">next</button>',
});

// Check for click events on the navbar burger icon
$('.navbar-burger').on('click', function () {

  // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
  $('.navbar-burger').toggleClass('is-active');
  $('.navbar-menu').toggleClass('is-active');

});


$('.has-dropdown .navbar-link').on('click', function () {
  $('.sub-menu').toggleClass('is-block');
})

$('.has-dropdown .sub-menu .has-dropdown .navbarlink').on('click', function () {
  $(this).closest('.sub-menu').toggleClass('is-block');
})



// WEBPACK FOOTER //
// ./scripts/main.js